const strings = {
  dashboard: {
    devicesOnline: "DEVICES ONLINE",
    water_percentage: "CWM WATER LEVEL",
    batteryLevel: "BATTERY LEVEL",
    tableHeader: {
      devices: (amtOfDevices: number) =>
        `Device${amtOfDevices === 1 ? "" : "s"} (${amtOfDevices})`,
      watered: "Last Watered",
      fill: "CWM water level",
      battery: "Battery %",
      location: "Location",
      online: "",
    },
    emptyTitle: "DEVICES NOT YET ADDED",
    emptyMessage:
      "No devices connected. Tap 'Add a Device' to begin. Setup is most convenient on mobile.",
  },
};

export default strings;
